import React, { useState } from 'react';
import { database } from '.././firebase';

const RedeemMiles = ({ userId }) => {
  const [cardNumber, setCardNumber] = useState('');
  const [message, setMessage] = useState('');

  // Function to replace dots and '@' in user ID with underscores
  const encodeUserId = (userId) => userId.replace(/\./g, '_').replace(/@/g, '_');

  const redeemGiftCard = async (cardNumber, userId) => {
    try {
      console.log(`Checking gift card: ${cardNumber}`);
      
      // Encode card number if needed
      const encodedCardNumber = cardNumber;  // Assuming no encoding needed for card number
      
      // Check the gift card
      const cardRef = database.ref(`giftcards/${encodedCardNumber}`);
      const cardSnapshot = await cardRef.once('value');
      const cardData = cardSnapshot.val();
      
      console.log(`Gift card data: ${JSON.stringify(cardData)}`);

      if (cardData && cardData.used === 0) {
        // Encode user ID
        const encodedUserId = encodeUserId(userId);
        
        console.log(`Checking user: ${encodedUserId}`);
        
        // Check the user
        const userRef = database.ref(`users/${encodedUserId}`);
        const userSnapshot = await userRef.once('value');
        const userData = userSnapshot.val();
        
        console.log(`User data: ${JSON.stringify(userData)}`);

        if (userData) {
          // Update user's balance
          const value = cardData.value;
          const newBalance = (userData.balance || 0) + value;
          await userRef.update({ balance: newBalance });

          // Mark the gift card as used
          await cardRef.update({ used: 1 });

          setMessage(`Gift card redeemed successfully. New balance: $${newBalance.toFixed(2)}`);
        } else {
          setMessage('User not found.');
        }
      } else {
        setMessage('Invalid or used gift card.');
      }
    } catch (error) {
      setMessage('Error redeeming gift card: ' + error.message);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (cardNumber && userId) {
      redeemGiftCard(cardNumber, userId);
    } else {
      setMessage('Please enter a gift card number and ensure user is logged in.');
    }
  };

  return (
    <div className="redeem-gift-card-container">
  <h3 className="send-money-title">Redeem Gift Card</h3>
  <form className="redeem-form" onSubmit={handleSubmit}>
    <div className="input-field">
      <input
        type="text"
        id="cardNumber"
        className="card-input"
        placeholder="Card Number"
        value={cardNumber}
        onChange={(e) => setCardNumber(e.target.value)}
        required
      />
    </div>
    <button type="submit" className="redeem-button">Redeem</button>
  </form>
  <p className="redeem-message">{message}</p>
</div>

  );
};

export default RedeemMiles;
